module.exports = "<button ng-click=\"$ctrl.preview()\" ng-disabled=\"$ctrl.pending\"\n        class=\"btn btn-default\"\n        uib-tooltip=\"{{'Save and Preview' | translate}}\"\n        tooltip-placement=\"bottom\"\n>\n    <em class=\"fa fa-eye\"></em>\n</button>";


//////////////////
// WEBPACK FOOTER
// ./src/cmsPages/Mails/Preview/preview.html
// module id = 985
// module chunks = 0